import './style.css';

function GrayButton({ buttonText, buttonWidth }) {
  return (
    <>
      <input type='button' className='gray-button' value={buttonText} style={{ width: buttonWidth }} />
    </>
  );
}

export default GrayButton;
